import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import Article from 'src/smoothr-web-app-core/models/Article';

@Component({
	selector: 'app-allergens-info-modal',
	templateUrl: './allergens-info-modal.component.html',
	styleUrls: ['./allergens-info-modal.component.scss'],
})
export class AllergensInfoModalComponent {
	desc: string;
	article: any;
	constructor(private modalCtrl: ModalController) {}
	static async show(modalCtrl: ModalController, article: Article) {
		console.log(article);
		const modal = await modalCtrl.create({
			cssClass: 'short-info-modal auto-height align-bottom-only-mobile',
			component: AllergensInfoModalComponent,
			componentProps: {
				article: article,
			},
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
	}

	dismiss() {
		this.modalCtrl.dismiss();
	}
}
